<template>
  <el-table :data="tableData" stripe ref="tableData" size="mini" style="width: 100%">
    <el-table-column prop="customer" :label="$t('cliente')"></el-table-column>
    <el-table-column width="200" sortable prop="tag" :label="$t('objeto')">
      <template slot-scope="scope">
        <TagLink :tag="scope.row.tag" back="PostObjectsSro" />
      </template>
    </el-table-column>
    <el-table-column prop="eventAt" :label="$t('data')" width="140" />
    <el-table-column prop="status" :label="$t('atual')" />
    <el-table-column prop="late" :label="$t('atrasado')">
      <template slot-scope="scope">
        <el-tag type="danger" v-if="scope.row.late === 'Sim'">{{ scope.row.late }}</el-tag>
        <el-tag type="success" v-else>{{ scope.row.late }}</el-tag>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import TagLink from '../../../../../views/dashboard/prepost/components/TagLink';

export default {
  name: 'PostSroMainTableData',
  props: ["tableData"],
  components: {
    TagLink,
  }
}
</script>